'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setVideoPosSeen = undefined;

var _reduxActions = require('redux-actions');

var setVideoPosSeen = exports.setVideoPosSeen = (0, _reduxActions.createAction)('TRACKING_VIDEO_POS_SEEN', function (videoId, second) {
  return { videoId: videoId, second: second };
});


//////////////////
// WEBPACK FOOTER
// ./program/frontend/actions/tracking.js
// module id = 879
// module chunks = 0